import moment from 'moment';
import Sales from '../../../services/sales';

export default{
  data() {
    return {
      dataTransfer: undefined,
      loading: undefined,
      summaryVP: {}
    }
  },
  computed: {
    getDateTransfer() {
      return moment().format('[Transferência efetuada às] H:mm [em] DD/MM/YYYY')
    },
    contractId: function(){
      
      return this.$route.params.contractId;
    }
  },
  methods: {
    print() {
      var prtContent = document.getElementById("comprovante");
      var WinPrint = window.open('', '', 'left=0,top=0,width=800,height=900,toolbar=0,scrollbars=0,status=0');
      WinPrint.document.write(prtContent.innerHTML);
      WinPrint.document.close();
      WinPrint.focus();
      WinPrint.print();
      WinPrint.close();
    }
  },
  mounted(){
      $('[data-toggle="tooltip"]').tooltip();
      this.loading = Sales.getTransferData(this.$route.params.orderId).then(resp => {
        
        this.dataTransfer = resp.response;
      }).catch(err => {
        
      });
    }
}



// WEBPACK FOOTER //
// ./src/pages/account/credit/transfer-credit-receipt.js